module.exports = __webpack_public_path__ + "img/device_1004_2_select.cce7d4fe.svg";